export default __webpack_public_path__ + "static/media/beeHealthyGardensDesktop.f2bede39.jpg";